import { useShouldShowGold as useShouldShowGoldMenu } from '@iheartjane/menu';

import { useGoldConfig } from '@jane/shared/data-access';
import { useSafeEcommApp } from '@jane/shared/providers';

export interface ShouldShowGoldProps {
  store?: {
    id?: string | number;
    state?: string | null;
  };
}

/** @deprecated use useShouldShowGoldMenu from '@iheartjane/menu' directly */
export const useShouldShowGold = (props?: ShouldShowGoldProps): boolean => {
  const { appMode } = useSafeEcommApp();
  const { data: goldConfig, isLoading: isLoadingGoldConfig } = useGoldConfig();
  const result = useShouldShowGoldMenu({
    appMode,
    goldConfig,
    state: props?.store?.state,
    storeId: props?.store?.id,
  });

  return isLoadingGoldConfig ? false : result;
};
